import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '@repo/videa-components/src/lib/utils';

export const TrendIndicator = ({
  value,
  suffix,
  decreasingIsPositive,
  isNeutral,
  isMinimal,
}: {
  value?: number;
  suffix?: string;
  decreasingIsPositive?: boolean;
  isNeutral?: boolean;
  isMinimal?: boolean;
}) => {
  if (!value) {
    return null;
  }

  const isIncreasing = value > 0;
  const isImproving =
    (isIncreasing && !decreasingIsPositive) ||
    (!isIncreasing && decreasingIsPositive);
  const absValue = Math.abs(value);

  // If minimal, show a less verbose version of the component
  if (isMinimal) {
    return (
      <FontAwesomeIcon
        icon={isIncreasing ? faArrowUp : faArrowDown}
        className={cn('vai-h-3 vai-w-3', {
          'vai-text-gray-600': isNeutral,
          'vai-text-green-700': !isNeutral && isImproving,
          'vai-text-blaze-600': !isNeutral && !isImproving,
        })}
      />
    );
  }

  return (
    <span
      className={cn(
        'vai-inline-flex vai-items-center vai-justify-center vai-rounded-full vai-px-2 vai-py-1 vai-text-[0.75rem] vai-gap-1 vai-h-[1.75rem]',
        {
          'vai-bg-gray-50 vai-text-gray-600': isNeutral,
          'vai-bg-green-50 vai-text-green-700': !isNeutral && isImproving,
          'vai-bg-blaze-50 vai-text-blaze-600': !isNeutral && !isImproving,
        },
      )}
    >
      {isIncreasing ? (
        <FontAwesomeIcon icon={faArrowUp} />
      ) : (
        <FontAwesomeIcon icon={faArrowDown} />
      )}
      {absValue > 1000 ? `1000+` : Math.round(absValue)}
      {suffix}
    </span>
  );
};
